var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInEditorMode)?_c('dr-wrapper',_vm._g(_vm._b({},'dr-wrapper',_vm.$props,false),_vm.wrapOn),[_c('dr-list-view-editor',{class:_vm.evaluateClasses(_vm.classes)})],1):_c('dr-list-view-component',_vm._b({class:_vm.evaluateClasses(_vm.classes),attrs:{"isAppInIFrame":_vm.isAppInIFrame}},'dr-list-view-component',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }